import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { euro } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

export const ResellerDiscountDialog = ({ quote, onClose, onSaved }) => {
  const [pct, setPct] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (quote) setPct(String(quote.reseller_discount_pct || "")); }, [quote]);
  if (!quote) return null;
  const base = quote.reseller_ht_base ?? quote.total_reseller_ht ?? 0;
  const p = Math.max(0, Math.min(100, Number(pct) || 0));
  const cost = base * (1 - p / 100);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/quotes/${quote.id}/reseller-discount`, { pct: p });
      toast.success("Remise revendeur enregistrée");
      onSaved(quote.id, data);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="reseller-discount-dialog">
        <DialogHeader>
          <DialogTitle>Remise revendeur — {quote.quote_number}</DialogTitle>
          <DialogDescription>{quote.reseller_name} · le prix client ne change pas.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          <div className="flex justify-between"><span>Coût revendeur HT (tarif)</span><span className="font-mono" data-testid="rd-base">{euro(base)}</span></div>
          <div><Label>Remise sur le coût revendeur (%)</Label>
            <Input type="number" min={0} max={100} value={pct} onChange={(e) => setPct(e.target.value)} className="mt-1" data-testid="rd-pct" /></div>
          <div className="flex justify-between"><span>Coût revendeur HT après remise</span><span className="font-mono" data-testid="rd-cost">{euro(cost)}</span></div>
          <div className="flex justify-between font-semibold"><span>Marge HT du vendeur</span><span className="font-mono text-[#c9a227]" data-testid="rd-margin">{euro((quote.total_public_ht || 0) - cost)}</span></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button onClick={save} disabled={busy} data-testid="rd-save">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
